import React from 'react';
import style from "../../styles/pujaDetails.module.css";
import { Typography } from '@mui/material';
const HeadingPuja = ({
  headline
}) => {
  return <>
      <Typography className={style.eKriyaHeader} data-sentry-element="Typography" data-sentry-source-file="HeadingPuja.jsx">
          {headline}
      </Typography>
      <div className={style.kriyaLine}>
      </div>
    </>;
};
export default HeadingPuja;